import { useLocation } from "react-router-dom";
import { Construction } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { allNavItems } from "@/lib/permissions";

export default function PlaceholderPage() {
  const { pathname } = useLocation();
  const item = allNavItems.find((i) => i.to === pathname) || { label: "Module", api: "—" };
  return (
    <div data-testid="placeholder-page">
      <PageHeader crumbs={[{ label: "ProdTrack", to: "/dashboard" }, { label: item.label }]} title={item.label} subtitle="Module en cours de reconstruction — phase suivante" />
      <div className="panel p-8 flex flex-col items-center text-center gap-2 max-w-xl">
        <Construction className="h-6 w-6 text-amber-400" />
        <div className="text-sm font-medium">Ce module sera construit après validation de la fondation.</div>
        <div className="text-xs text-muted-foreground">Le backend V2.39 expose déjà les API nécessaires :</div>
        <code className="text-[11px] font-mono text-primary bg-muted/40 border border-border rounded-sm px-2 py-1">{item.api}</code>
      </div>
    </div>
  );
}
